import { useIntl } from "react-intl";

import useRerenderer from "@mapmycustomers/shared/util/hook/useRerenderer";
import { useNonNullableContext } from "@mapmycustomers/shared/util/react";

import EmailContext from "@app/component/email/creation/EmailContext";
import useEmailDraftInfoGetter from "@app/util/email/useEmailDraftInfoGetter";
import { formatDateDistance } from "@app/util/formatters";
import useInterval from "@app/util/hook/useInterval";
import { parseApiDate } from "@app/util/parsers";

import messages from "./messages";

const REFRESH_INTERVAL_MS = 5000;

const useDraftSavedLabel = () => {
  const intl = useIntl();
  const draftInfoGetter = useEmailDraftInfoGetter();

  useInterval(useRerenderer(), true, REFRESH_INTERVAL_MS);

  const { draftId } = useNonNullableContext(EmailContext);
  const savedDraftInfo = draftId ? draftInfoGetter(draftId, intl) : undefined;

  if (!savedDraftInfo) {
    return null;
  }

  return intl.formatMessage(messages.savedLabel, {
    relativeTime: formatDateDistance(parseApiDate(savedDraftInfo.draft.updatedAt), new Date(), {
      addSuffix: true,
      includeSeconds: true,
    }),
  });
};

export default useDraftSavedLabel;
